import _ from "lodash";
import { useEffect, useState } from "react";
import { useNotification } from "../../context/notification";
import { dayJS } from "../../utils/datetime";

import Button from "@material-ui/core/Button";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import LinkIcon from "@material-ui/icons/Link";
import ScheduleIcon from "@material-ui/icons/Schedule";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import BackButton from "../../components/BackButton";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import Select from "../../components/Select";
import SessionBasicInfo from "../../components/SessionBasicInfo";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import { apiRequest } from "../../utils/api";
import styles from "./WarningSession.module.scss";

export function WarningSession() {
  const history = useHistory();
  const { addNotification } = useNotification();
  const { id } = useParams();
  const sessionId = id.split(":")[0];
  const subjectId = id.split(":")[1];
  const [isLoading, setIsLoading] = useState(false);
  const [sessionDetails, setSessionDetails] = useState({});
  const [dateDropdownList, setDateDropdownList] = useState(null);

  useEffect(() => {
    apiRequest
      .get(
        `/api/warningLetter/session/subject?session_id=${sessionId}&subject_id=${subjectId}`
      )
      .then(response => {
        const data = response.data.data;
        setSessionDetails(data);
      })
      .catch(error => {
        console.error(error);
      });

    //Get date dropdown

    apiRequest
      .get(
        `/api/getHRViewWarningDates?session_id=${sessionId}&subject_id=${subjectId}`
      )
      .then(response => {
        let data = response.data.data;
        data = data.dates.map(item => {
          return {
            value: item,
            label: item,
          };
        });

        setDateDropdownList(data);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  // helper function to access values within session details
  const getSessionValue = key => {
    return sessionDetails ? sessionDetails[key] : undefined;
  };
  const handleDateChange = value => {
    if (value === dateDropdownList[0].value) {
      history.push(`/warningLetters/session/${sessionId}:${subjectId}`);
    } else {
      history.push(
        `/sessions/archive-session/${getSessionValue(
          "session_id"
        )}?date=${dayJS(value).format("DD MMM YYYY")}&subjectId=${subjectId}`
      );
    }
  };

  return (
    <>
      {!_.isEmpty(sessionDetails) && (
        <DashboardLayout
          //dropdown for selecting dates
          appBarContent={
            <div className={styles.appBar}>
              <BackButton style={{ paddingBottom: "0" }} />
              {dateDropdownList && (
                <Select
                  className={styles.topDropdown}
                  list={dateDropdownList}
                  value={dateDropdownList[0].value}
                  onChange={e => {
                    handleDateChange(e.target.value);
                  }}
                />
              )}
            </div>
          }
          contentClass={styles.dashboardLayout__content}
        >
          {sessionDetails && (
            <div className={styles.pageWrapper}>
              <PageContent indent>
                <Section>
                  <SectionTitle>
                    {dayJS(
                      getSessionValue("warning_issued_date")[0].date
                    ).format("DD MMM YYYY")}
                  </SectionTitle>
                  <div className={styles.detailsContainer}>
                    <div className={styles.sessionDetailsBlock}>
                      <SessionBasicInfo sessionData={sessionDetails} />
                      <div className={styles.row}>
                        <div className={styles.rowLeft}>Coaching date</div>
                        <div className={styles.rowRight}>
                          <span className={styles.rowIcon}>
                            <CalendarTodayIcon />
                          </span>
                          <span style={{ padding: "0 12px 0 4px" }}>
                            {/* Time format: 9 Jan 2020 */}
                            {dayJS(getSessionValue("coaching_datetime"))
                              .add(dayJS().utcOffset(), "minutes")
                              .format("D MMM YYYY")}
                          </span>
                          <span className={styles.rowIcon}>
                            <ScheduleIcon />
                          </span>
                          <span style={{ padding: "0 12px 0 4px" }}>
                            {/* Time format: 8:12 PM*/}
                            {dayJS(getSessionValue("coaching_datetime"))
                              .add(dayJS().utcOffset(), "minutes")
                              .format("h:mm A")}
                          </span>
                        </div>
                      </div>
                      <div className={styles.row}>
                        <div className={styles.rowLeft}>Review date</div>
                        <div className={styles.rowRight}>
                          <span className={styles.rowIcon}>
                            <CalendarTodayIcon />
                          </span>
                          <span style={{ padding: "0 12px 0 4px" }}>
                            {/* Time format: 9 Jan 2020 */}
                            {dayJS(getSessionValue("review_datetime"))
                              .add(dayJS().utcOffset(), "minutes")
                              .format("D MMM YYYY")}
                          </span>
                          <span className={styles.rowIcon}>
                            <ScheduleIcon />
                          </span>
                          <span style={{ padding: "0 12px 0 4px" }}>
                            {/* Time format: 8:12 PM*/}
                            {dayJS(getSessionValue("review_datetime"))
                              .add(dayJS().utcOffset(), "minutes")
                              .format("h:mm A")}
                          </span>
                        </div>
                      </div>
                      <div className={styles.row}>
                        <div className={styles.rowLeft}>Method</div>
                        <div className={styles.rowRight}>
                          {getSessionValue("method")}
                        </div>
                      </div>
                      <div className={styles.row}>
                        <div className={styles.rowLeft}>Type of sessions</div>
                        <div className={styles.rowRight}>
                          {getSessionValue("session_type")}
                        </div>
                      </div>
                      <div
                        className={styles.row}
                        style={{ paddingBottom: "10px" }}
                      >
                        <div className={styles.rowLeft}></div>
                        <div
                          className={`${styles.rowRight} ${styles.subjectFiled}`}
                        ></div>
                      </div>
                      <div className={styles.row}>
                        <div className={styles.rowLeft}>Subject</div>
                        <div className={`${styles.rowRight}`}>
                          <div className={styles.subject}>
                            <span className={styles.index}>1</span>
                            {getSessionValue("subject")}
                          </div>
                          <div className={styles.subject}>
                            <span className={styles.subjectMetricsValue}>
                              {getSessionValue("review_progress")}
                            </span>
                            {getSessionValue("document_link") && (
                              <Button
                                className={styles.viewLinkBtn}
                                variant="outlined"
                                name="subjects"
                                disableRipple
                                disableElevation
                                title={getSessionValue("document_link")}
                                onClick={() => {
                                  window.open(getSessionValue("document_link"));
                                }}
                              >
                                <LinkIcon className={styles.viewLinkBtnIcon} />
                                <span className={styles.viewLinkBtnLabel}>
                                  View link
                                </span>
                              </Button>
                            )}
                          </div>

                          <div className={styles.subject}>
                            <div className={styles.warningListWrapper}>
                              <ul>
                                {getSessionValue("warning_issued_date") &&
                                  getSessionValue("warning_issued_date").map(
                                    (item, index) => (
                                      <li>
                                        Previous misconduct
                                        {index === 0 && (
                                          <span className={styles.warningDate}>
                                            {dayJS(item.date).format(
                                              "DD MMM YYYY"
                                            )}
                                          </span>
                                        )}
                                        {index !== 0 && (
                                          <Link
                                            style={{ margin: "0 5px" }}
                                            to={`/sessions/archive-session/${getSessionValue(
                                              "session_id"
                                            )}?date=${dayJS(item.date).format(
                                              "DD MMM YYYY"
                                            )}&subjectId=${subjectId}`}
                                          >
                                            {dayJS(item.date).format(
                                              "DD MMM YYYY"
                                            )}{" "}
                                            session
                                          </Link>
                                        )}
                                        <span className={styles.warningText}>
                                          {item.msg}
                                        </span>
                                      </li>
                                    )
                                  )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Section>
              </PageContent>
            </div>
          )}
        </DashboardLayout>
      )}
    </>
  );
}
